import { axiosInstance } from "../authService";
import ApiUrlConstant from "../Constants";

const headers = { "Ocp-Apim-Subscription-Key": process.env.REACT_APP_API_KEY };

const LogService = {
    getAuditLogs: (params = {}, token) => {
        return axiosInstance.get(ApiUrlConstant.getAuditLogs(), {
            params,
            headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        });
    },
    getAuditLogsById: (params = {}, token) => {
        return axiosInstance.get(ApiUrlConstant.getAuditLogsById(), {
            params,
            headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        });
    },
};

export default LogService;
